import * as Sentry from '@sentry/react';

const CORRELATION_HEADER = 'X-Correlation-Id';
const CLIENT_APP_HEADER = 'X-Client-App';
const CLIENT_VERSION_HEADER = 'X-Client-Version';

const CLIENT_APP = 'stadium-manage';
const CLIENT_VERSION = process.env.REACT_APP_ENV || 'development';

export const newCorrelationId = (): string => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return `${CLIENT_APP}-${crypto.randomUUID()}`;
    }
  } catch (error) {}

  return `${CLIENT_APP}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};

export const apiFetch = async (
  input: RequestInfo | URL,
  init: RequestInit = {},
  correlationId?: string
): Promise<Response> => {
  const resolvedCorrelationId = correlationId || newCorrelationId();
  const headers = new Headers(init.headers || {});

  headers.set(CORRELATION_HEADER, resolvedCorrelationId);
  headers.set(CLIENT_APP_HEADER, CLIENT_APP);
  headers.set(CLIENT_VERSION_HEADER, CLIENT_VERSION);

  const startedAt = Date.now();

  try {
    const response = await fetch(input, { ...init, headers });

    if (!response.ok) {
      Sentry.captureMessage('api_fetch_request_failed', {
        level: 'warning',
        tags: { correlation_id: resolvedCorrelationId, status: String(response.status) },
        extra: { url: String(input), durationMs: Date.now() - startedAt },
      });
    }

    return response;
  } catch (error) {
    Sentry.captureException(error, {
      tags: { correlation_id: resolvedCorrelationId },
      extra: { url: String(input), durationMs: Date.now() - startedAt },
    });
    throw error;
  }
};

export const traceAction = (action: string, details?: Record<string, any>): string => {
  const correlationId = newCorrelationId();

  Sentry.addBreadcrumb({
    category: 'action',
    message: action,
    data: { correlationId, ...(details || {}) },
    level: 'info',
  });

  return correlationId;
};
